/* eslint-disable @next/next/no-img-element */
import { ASSET_PREFIX } from 'utils/constants';

export const BoostIcon = () => {
  return (
    <>
      <img
        src={`${ASSET_PREFIX}/images/enter/rocket.png`}
        alt=""
        className="rocketImage actionIcon"
      />
      <style jsx>
        {`
          .rocketImage {
            width: 38px;
            height: 38px;
            margin-right: 0.25rem;
            vertical-align: middle;
            padding: 6.5px;
          }
        `}
      </style>
    </>
  );
};
